import React, {useMemo} from "react"
import {useTranslation} from "react-i18next"
import {KlassDropdown, KlassDropdownAsyncProps} from "../Select"
import {useAllDepartments} from "hooks"
import {Modules, useEdularModulesContext} from "@edular/modules"
import {BaseDepartmentId} from "types/departments"

type Props = Partial<KlassDropdownAsyncProps> & {}

const MAP_DIALER_DEPARTMENTS = {
    [Modules.AdmissionsDialer]: BaseDepartmentId.Admissions,
    [Modules.FinancialAidDialer]: BaseDepartmentId.FinancialAid,
    [Modules.AcademicDialer]: BaseDepartmentId.Academics,
    [Modules.StudentAccountDialer]: BaseDepartmentId.StudentAccount,
    [Modules.CareerServicesDialer]: BaseDepartmentId.CareerServices,
    [Modules.StudentServicesDialer]: BaseDepartmentId.StudentServices,
    [Modules.AcademicAffairDialer]: BaseDepartmentId.AcademicAffair
}

const DepartmentDialerSelect: React.FC<Props> = (props: Props) => {
    const {t} = useTranslation(["common"])
    const {departments} = useAllDepartments()
    const {isModuleEnable} = useEdularModulesContext()

    const options = useMemo(() => {
        let enabledDepartments = []
        Object.entries(MAP_DIALER_DEPARTMENTS).forEach(([moduleId, departmentId]) => {
            if (isModuleEnable(parseInt(moduleId) as Modules)) {
                enabledDepartments.push(departments.find((dept) => dept.departmentId === departmentId))
            }
        })
        return enabledDepartments
    }, [departments, isModuleEnable])

    return (
        <KlassDropdown placeholder={props.placeholder || t("selectField.placeholder")} options={options} {...props} />
    )
}

export default DepartmentDialerSelect
